import { Button } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";

interface FacebookLoginButtonProps {
  onClick: () => void;
  isDisabled?: boolean;
}

const FacebookLoginButton = ({
  onClick,
  isDisabled,
}: FacebookLoginButtonProps) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={isDisabled}
      startIcon={<FacebookIcon />}
      fullWidth
      sx={{
        height: 50,
        backgroundColor: "#4267B2",
        "&:hover": {
          backgroundColor: "#365899",
        },
        textTransform: "none",
        fontFamily: "Roboto, Arial, sans-serif",
        fontSize: "16px",
        lineHeight: "48px",
      }}
    >
      Sign in with Facebook
    </Button>
  );
};

export default FacebookLoginButton;
